module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && (_vm.product.labels && _vm.product.labels.length)) ? _c('div', {
    staticClass: "labels"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.product.labels), function(label, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!_vm.moreopen && index > 2) ? false : true),
        expression: "(!moreopen && index > 2) ? false : true"
      }],
      staticClass: "label",
      class: {
        'invalid': !label.valid
      },
      on: {
        "click": function($event) {
          return _vm.jump(label)
        }
      }
    }, [_c('span', {
      staticClass: "summary",
      style: ({
        color: label.summaryColor
      })
    }, [_c('div', {
      staticClass: "tg"
    }, [_c('span', {
      staticClass: "type",
      style: ({
        color: label.typeColor,
        backgroundColor: label.typeBgColor
      })
    }, [_vm._v(_vm._s(label.type))])]), _vm._v(" "), (label.summary) ? _c('span', {
      staticClass: "sm"
    }, [_vm._v(_vm._s(label.summary))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (label.count) ? _c('span', {
      staticClass: "count"
    }, [_vm._v("x" + _vm._s(label.count))]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "arrow"
    })])
  }), 0)]), _vm._v(" "), (_vm.product.labels.length > 3) ? _c('div', {
    staticClass: "more"
  }, [(!_vm.moreopen) ? _c('div', {
    on: {
      "click": _vm.showLabelMore
    }
  }, [_vm._v("查看其他" + _vm._s(_vm.product.labels.length - 3) + "个活动"), _c('i')]) : _c('div', {
    on: {
      "click": _vm.showLabelMore
    }
  }, [_vm._v("收起"), _c('i', {
    staticClass: "up"
  })])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-551c897b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/labels.vue
// module id = 1013
// module chunks = 2